module.exports = __webpack_public_path__ + "img/payment01.518134a2.png";